import {Injectable, NgZone} from '@angular/core';
import { Location } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSidenav } from '@angular/material/sidenav';
import { App } from '@capacitor/app';
import {MatSnackBar} from "@angular/material/snack-bar";
import {LayoutService} from "./layout.service";
import {SidenavService} from "./sidenav.service";
import {SettingsService} from "./settings.service";
import {ContinuousPlaybackService} from "./continuous-playback.service";
import {translation} from "../translation";

@Injectable({
  providedIn: 'root'
})
export class BackButtonService {

  private backButtonActions: (() => void)[] = [];

  constructor(private location: Location,
              private platform: Platform,
              private layoutService: LayoutService,
              private sidenavService: SidenavService,
              private zone: NgZone,
              private snackbar: MatSnackBar,
              private settingsService: SettingsService,
              private continuousPlaybackService: ContinuousPlaybackService,) {
    this.initializeBackButtonHandler();
  }

  private async initializeBackButtonHandler() {
    if (this.platform.ANDROID) {
      await App.addListener('backButton', () => {
        this.handleBackButton();
      });
    }
  }

  async handleBackButton() {
    if(this.backButtonActions.length > 0) {
      console.debug('Handling registered back button action');
      this.backButtonActions[this.backButtonActions.length - 1]();
      this.backButtonActions.pop();
    } else if (this.layoutService.singleView) {
      if (this.sidenavService.settingsOpened) {
        console.debug('Closing settings');
        this.settingsService.toggleSettings();
      } else if (this.continuousPlaybackService.active) {
        console.debug('Stopping continuous playback');
        await this.continuousPlaybackService.stopContinuousPlayback();
      } else if (!this.sidenavService.hymnListToggleSubject.value) {
        console.debug('Opening list');
        this.sidenavService.openList();
      } else {
        this.handleCloseApp();
      }
    }
    else {
      this.handleCloseApp();
    }
  }

  readyToClose = false;
  handleCloseApp() {
    if (this.layoutService.isNotBrowser()) {
      if (!this.readyToClose) {
        console.debug('Ready to close');
        this.readyToClose = true;

        this.zone.run(() => {
          this.snackbar.open(translation.press_back_to_exit, '', {
            duration: 2000,
          });
        });

        setTimeout(() => {
          this.readyToClose = false;
        }, 2000);
      }
      else {
        console.debug('Exiting app');
        this.readyToClose = false;
        App.exitApp();
      }
    }
  }

  registerBackButtonAction(param: () => void) {
    this.backButtonActions.push(param);
  }
}
